import React from 'react';
import { Button, makeStyles, Typography } from '@material-ui/core';

// Kit outline button: bordered flat surface, hover to --accent, md radius
const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20,
    width: '100%',
    minHeight: 36,
  },
  icon: {
    width: 16,
    height: 16,
  },
  label: {
    fontSize: 'var(--text-label)',
    lineHeight: 'var(--text-label--line-height)',
    fontWeight: 500,
    color: 'var(--fg-heading)',
  },
}));

interface Props {
  icon?: any;
  label: string;
  onClick: VoidFunction;
  id?: string;
}

export function SignInActionButton({ icon, label, onClick, id }: Props) {
  const classes = useStyles();

  return (
    <Button
      variant="outlined"
      startIcon={<img className={classes.icon} src={icon} alt="" />}
      id={id}
      className={classes.root}
      onClick={onClick}
    >
      <Typography className={classes.label}>{label}</Typography>
    </Button>
  );
}
